"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var scheduler_1 = require("scheduler");
exports.scheduler = {
    applyWithIdlePriority: function (callback) {
        scheduler_1.unstable_scheduleCallback(scheduler_1.unstable_IdlePriority, callback);
    },
    applyWithLowPriority: function (callback) {
        scheduler_1.unstable_scheduleCallback(scheduler_1.unstable_LowPriority, callback);
    },
    applyWidthNormalPriority: function (callback) {
        scheduler_1.unstable_scheduleCallback(scheduler_1.unstable_NormalPriority, callback);
    }
};
